import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectFieldDefinitionInfo } from './ProjectFieldDefinitionInfo.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectFieldDefinitionInfoNodesFragment = { __typename?: 'Project', fieldDefinitions?: { __typename?: 'ProjectFieldDefinitionConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectFieldDefinition', fieldType: Types.FieldTypeEnum, id: string, isDefaultField?: boolean | null, isFilterable?: boolean | null, isGroupable?: boolean | null, isSortable?: boolean | null, isSystemField: boolean, name: string, configuration?: { __typename?: 'DateFieldConfiguration', displayFormat?: Types.DisplayFormatEnum | null, displayTimezone?: boolean | null, includeTime?: boolean | null, timeFormat?: Types.TimeFormatEnum | null } | { __typename?: 'NumberFieldConfiguration', scale?: number | null } | { __typename?: 'RatingFieldConfiguration', color?: string | null, maxValue: number, style?: Types.RatingStyleEnum | null } | { __typename?: 'SelectFieldConfiguration', options: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string }> } | { __typename?: 'ToggleFieldConfiguration', color?: string | null } | { __typename?: 'UserFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | { __typename?: 'UsersFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, selectType: Types.MemberSelectTypeEnum, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export const ProjectFieldDefinitionInfoNodes = /*#__PURE__*/ gql`
    fragment ProjectFieldDefinitionInfoNodes on Project {
  fieldDefinitions(
    page: {first: 100}
    filters: {name: $query, excludeSystemFields: $excludeSystemFields, excludeInactiveField: true}
  ) {
    nodes {
      ...ProjectFieldDefinitionInfo
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${ProjectFieldDefinitionInfo}` as unknown as DocumentNode<ProjectFieldDefinitionInfoNodesFragment, unknown>;

        

        
export const useProjectFieldDefinitionInfoNodesFragment = (
  input: string | Omit<UseFragmentOptions<ProjectFieldDefinitionInfoNodesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectFieldDefinitionInfoNodesFragment>({
    fragment: ProjectFieldDefinitionInfoNodes,
    fragmentName: 'ProjectFieldDefinitionInfoNodes',
    ...options,
  });
};
  
        